import React from 'react';
import type { ImageVariantCounts } from '@/api/ProductImages/types';
import { useTranslate } from '@/translations';
import {
  variantLabel,
  variantPresentation,
} from '@/modules/ProductImages/variantImageMessages';

export const VariantCounts = ({
  counts,
}: {
  counts?: ImageVariantCounts[];
}) => {
  const { t } = useTranslate();
  return (
    <>
      {(counts ?? []).map((variant) => (
        <dl
          className="imagery-counts"
          key={variant.variantKey}
          aria-label={variantLabel(t, variant.variantKey)}
        >
          {(
            [
              'pendingCount',
              'succeededCount',
              'failedCount',
              'unknownCount',
              'stoppedCount',
            ] as const
          ).map((field) => (
            <div key={field}>
              <dt>
                {t(variantPresentation(variant.variantKey)[field], {
                  style: variantLabel(t, variant.variantKey),
                })}
              </dt>
              <dd>{variant[field]}</dd>
            </div>
          ))}
        </dl>
      ))}
    </>
  );
};
